<template>
    <div v-if="labels.length" class="cert-pending">
        <p class="cert-pending__title">{{ $t('student.certificates.pendingActivities') }}</p>
        <ul>
            <li v-for="(label, index) in visibleLabels" :key="`${label}-${index}`" :title="label">
                {{ label }}
            </li>
        </ul>
        <p v-if="hiddenCount > 0" class="cert-pending__more">
            {{ $t('student.certificates.morePending', { n: hiddenCount }) }}
        </p>
    </div>
</template>

<script>
    export default {
        name: 'CertificatePending',
        props: {
            labels: { type: Array, default: () => [] },
        },
        computed: {
            visibleLabels() {
                return this.labels.slice(0, 3);
            },
            hiddenCount() {
                return Math.max(0, this.labels.length - 3);
            },
        },
    };
</script>

<style scoped>
    .cert-pending {
        width: 100%;
        min-width: 0;
        text-align: left;
        justify-self: stretch;
        padding-right: 16px;
        border-right: 1px solid var(--certs-pending-line, #e6e8ee);
    }

    .cert-pending__title {
        margin: 0 0 6px;
        font-size: 0.72rem;
        font-weight: 600;
        text-align: left;
        color: #9ca3af;
    }

    .cert-pending ul {
        margin: 0;
        padding: 0;
        list-style: none;
        text-align: left;
    }

    .cert-pending li {
        position: relative;
        padding-left: 12px;
        color: var(--certs-pending-text, #6b7280);
        font-size: 0.75rem;
        line-height: 1.35;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .cert-pending li::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0.55em;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #9ca3af;
    }

    .cert-pending__more {
        margin: 4px 0 0;
        font-size: 0.75rem;
        font-weight: 600;
        text-align: left;
        color: #9ca3af;
    }

    @media (max-width: 860px) {
        .cert-pending {
            border-right: 0;
            padding-right: 0;
        }
    }
</style>
